
import React from 'react';
import { Property, User } from '../types';
import { generatePortfolioDossier } from '../services/pdfService';
import { FileText, Download, PieChart, ShieldCheck } from 'lucide-react';

interface ReportsCenterProps {
  properties: Property[];
  user: User;
}

const ReportsCenter: React.FC<ReportsCenterProps> = ({ properties, user }) => {
  
  const handleGenerate = () => {
      generatePortfolioDossier(properties, user.name);
  };

  return (
    <div className="p-8 max-w-5xl mx-auto h-full flex flex-col">
        <div className="mb-10">
            <h2 className="text-4xl font-black text-white tracking-tight mb-2 flex items-center gap-3">
                <FileText className="w-8 h-8 text-emerald-500" />
                Reports Center
            </h2>
            <p className="text-slate-400 font-mono text-xs tracking-widest">INVESTOR RELATIONS & BANKING</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
            {/* Portfolio Dossier Card */}
            <div className="bg-slate-900/60 backdrop-blur-md border border-slate-800 p-8 rounded-3xl relative overflow-hidden group">
                <div className="absolute top-0 right-0 p-32 bg-emerald-500/5 rounded-full blur-3xl group-hover:bg-emerald-500/10 transition-colors"></div>
                
                <div className="relative z-10">
                    <div className="w-12 h-12 bg-slate-950 rounded-xl flex items-center justify-center border border-slate-800 mb-6">
                        <PieChart className="w-6 h-6 text-emerald-500" />
                    </div>
                    
                    <h3 className="text-2xl font-bold text-white mb-2">Portfolio Dossier</h3>
                    <p className="text-slate-400 mb-8 leading-relaxed">
                        A comprehensive, bank-ready PDF report summarizing your entire portfolio's performance. Includes Executive Summary, Net Equity calculations, LTV analysis, and individual asset sheets.
                    </p>

                    <div className="space-y-3 mb-8">
                        <div className="flex items-center gap-3 text-sm text-slate-300">
                            <ShieldCheck className="w-4 h-4 text-emerald-500" /> Professional Cover Page
                        </div>
                        <div className="flex items-center gap-3 text-sm text-slate-300">
                            <ShieldCheck className="w-4 h-4 text-emerald-500" /> Aggregated Financial Metrics
                        </div>
                        <div className="flex items-center gap-3 text-sm text-slate-300">
                            <ShieldCheck className="w-4 h-4 text-emerald-500" /> Asset Matrix Table
                        </div>
                    </div>

                    <button 
                        onClick={handleGenerate}
                        className="w-full py-4 bg-emerald-600 hover:bg-emerald-500 text-white font-bold rounded-xl shadow-lg shadow-emerald-900/20 flex items-center justify-center gap-2 transition-all transform hover:-translate-y-1"
                    >
                        <Download className="w-5 h-5" /> Generate PDF Dossier
                    </button>
                </div>
            </div>

            {/* Coming Soon: Tax Report */}
            <div className="bg-slate-900/30 border border-slate-800/50 p-8 rounded-3xl relative overflow-hidden opacity-75">
                 <div className="w-12 h-12 bg-slate-950 rounded-xl flex items-center justify-center border border-slate-800 mb-6">
                    <FileText className="w-6 h-6 text-slate-500" />
                </div>
                <h3 className="text-2xl font-bold text-slate-300 mb-2">Fiscal Report (IRS/IRC)</h3>
                <p className="text-slate-500 mb-8 leading-relaxed">
                    Automated pre-fill for Annex F (Rents). Calculates deductible expenses per property logic.
                </p>
                <button disabled className="w-full py-4 bg-slate-800 text-slate-500 font-bold rounded-xl border border-slate-700 cursor-not-allowed">
                    Coming Soon in v3.0
                </button>
            </div>
        </div>
    </div>
  );
};

export default ReportsCenter;
